import { render, staticRenderFns } from "./GiftBoxSymbols.vue?vue&type=template&id=8bd5253c&"
import script from "./GiftBoxSymbols.vue?vue&type=script&lang=js&"
export * from "./GiftBoxSymbols.vue?vue&type=script&lang=js&"
import style0 from "./GiftBoxSymbols.vue?vue&type=style&index=0&id=8bd5253c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports